import { Box, Select, Text } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import FilterContext from '../../../../../contexts/FilterContext';
import VisualizationContext from '../../../../../contexts/VisualizationContext';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getDadosLogin } from '../../../../../utils/dados-login.util';
import { isJson } from '../../../../../utils/isJson.util';

type PageSubHeaderLeadsProps = {
  title?: string;
  isBeta?: boolean;
  isGestor?: boolean;
};

export const PageSubHeaderLeadsKanbanGestor = ({
  title,
  isGestor,
  isBeta
}: PageSubHeaderLeadsProps) => {
  const [listaVendedores, setListaVendedores] = useState<
    {
      id?: string;
      tipo?: string;
      nome?: string;
      id_vendedor?: string;
      login?: string;
    }[]
  >([]);

  const [isUserManager, setUserManager] = useState(true);

  const [actualUser, setActualUser] = useState('');

  const isMobile = useMediaQuery('(max-width: 920px)');
  const { filterObject, setFilterObject, setLoadingFilters } =
    useContext(FilterContext);
  const navigate = useNavigate();

  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);

  const handleVisualizationState = (value: string) => {
    navigate('/corretor/leads');

    setVisualizationState(value);
  };

  const userData = localStorage.getItem('pdn:user')
    ? JSON.parse(localStorage.getItem('pdn:user'))
    : { user: { name: '' } };

  const fetchListaVendedores = async () => {
    try {
      const perfis = await apiSensedia.get(
        '/oportunidades-sulamerica/painel-leads/gestao/perfis'
      );

      const vendedores = perfis?.data?.filter(
        (vendedor: any) =>
          vendedor.tipo === 'clt' || vendedor.tipo === 'autonomo'
      );

      setListaVendedores(vendedores || []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMudarVendedor = async (val: any) => {
    const vendedor = listaVendedores.find((element: any) => {
      return element.id_vendedor === val;
    });
    setFilterObject({
      ...filterObject,
      headers: {
        ...filterObject.headers,
        login: val === '' ? null : vendedor.id
      }
    });
  };

  const setUserRole = () => {
    const user = localStorage.getItem('pdn:user');
    if (isJson(user)) {
      const parsedUser = JSON.parse(user);

      if (parsedUser?.user) {
        setUserManager(Boolean(parsedUser.user.isManager));
        if (Boolean(parsedUser.user.isManager) === true) fetchListaVendedores();
      }
    }
  };

  useEffect(() => {
    getDadosLogin().then((dadosLogin) => {
      if (dadosLogin.isManager) fetchListaVendedores();
    });

    setUserRole();
    setActualUser(
      filterObject?.headers?.login ? filterObject?.headers?.login : ''
    );
  }, []);
  useEffect(() => {
    setActualUser(
      filterObject?.headers?.login ? filterObject?.headers?.login : ''
    );
  }, [filterObject]);
  return (
    <div className="tw-bg-[#ebebeb] tw-px-[16px] tw-py-[30px] md:tw-px-14 md:tw-py-[1.88rem]">
      <div
        className={
          isMobile
            ? 'tw-flex tw-flex-col tw-justify-between tw-items-start'
            : 'tw-flex tw-justify-between tw-items-center'
        }
      >
        <div className="tw-flex tw-gap-[0.63rem] tw-justify-center tw-items-start tw-flex-col">
          <h1
            className={
              isMobile
                ? 'tw-text-[1.5rem] tw-font-bold'
                : 'tw-text-2xl tw-font-bold'
            }
          >
            {title}
          </h1>
          {isUserManager ? (
            <div className="tw-flex tw-w-full tw-items-center tw-gap-[0.7rem]">
              <p className="tw-text-[1.2rem]">
                Gestor:{' '}
                <span className="tw-font-bold">
                  {userData.user.name.split(' ')[0]}
                </span>
              </p>
              <div className="tw-w-48 tw-rounded-full">
                <select
                  className="tw-bg-white tw-font-bold tw-text-orange-500 tw-outline-none tw-border-2 tw-border-orange-500 tw-w-48 tw-text-center tw-rounded-full tw-h-9"
                  defaultValue={actualUser}
                  onChange={(e) => {
                    handleMudarVendedor(e.target.value);
                  }}
                >
                  <option className="tw-text-gray-400" value="">
                    Alterar Vendedor
                  </option>
                  {/* Mapping through vendedores */}
                  {listaVendedores.map((vendedor) => (
                    <option
                      selected={actualUser === vendedor.id}
                      value={vendedor.id}
                      className="tw-text-black"
                      key={vendedor.id}
                    >
                      {vendedor.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : (
            <></>
          )}

          {isBeta ? (
            <p className="tw-bg-[#001E64] tw-text-white tw-text-[0.75rem] tw-w-[2.4375rem] tw-h-[1.5rem] tw-rounded-[0.46875rem] tw-flex tw-justify-center tw-items-center">
              Beta
            </p>
          ) : null}
        </div>
        <hr className="tw-bg-[#D2D2D2] tw-h-[1px] tw-w-full tw-my-[20px] md:tw-hidden" />
        {isGestor ? (
          <div
            className={
              isMobile ? 'tw-bg-[#EBEBEB] tw-rounded-md tw-text-[1rem]' : ''
            }
          >
            <div
              className={
                isMobile ? 'tw-font-bold tw-text-[1rem]' : 'tw-font-bold'
              }
            >
              Alterar modo de visualização
            </div>

            <div
              className={
                isMobile
                  ? 'tw-flex tw-flex-col tw-gap-[10px] tw-mt-[10px]'
                  : 'tw-flex tw-gap-2'
              }
            >
              <div className="tw-flex tw-gap-1">
                <div className="tw-flex tw-items-center tw-gap-1">
                  <input
                    name="options"
                    value="gestao"
                    onChange={(e) => {
                      handleVisualizationState(e.target.value);
                    }}
                    type="radio"
                    defaultChecked={visualizationState === 'gestao'}
                    className={
                      isMobile ? 'tw-text-[1.2rem] tw-font-bold' : 'tw-text-2xl'
                    }
                  />
                  <div className={isMobile ? 'tw-text-[1rem]' : ''}>
                    Modelo de Gestão
                  </div>
                </div>
              </div>
              <div className="tw-flex tw-items-center tw-gap-1">
                <div>
                  <input
                    name="options"
                    type="radio"
                    value="card"
                    onChange={(e) => {
                      handleVisualizationState(e.target.value);
                    }}
                    defaultChecked={visualizationState === 'card'}
                    className={
                      isMobile ? 'tw-text-[1.2rem] tw-font-bold' : 'tw-text-2xl'
                    }
                  />
                </div>
                <div className={isMobile ? 'tw-text-[1rem]' : ''}>
                  Modelo de Cards
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
